import type { RuntimeConfig } from '@ai-secure-twin/shared';
import { Amplify } from 'aws-amplify';

/**
 * Configures Amplify Auth v6 against the Cognito user pool in the runtime config.
 *
 * Sign-in goes through the Cognito **Hosted UI** using authorization code + PKCE. That is what
 * `AuthStack` provisions (no client secret, implicit flow disabled), and it is what makes MFA
 * workable: the pool requires MFA, and the Hosted UI handles both first-time TOTP enrolment and
 * the per-sign-in challenge. A bespoke form would have to reimplement both.
 */
export function configureAmplify(config: RuntimeConfig): void {
  const origin = window.location.origin;

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.userPoolId,
        userPoolClientId: config.userPoolClientId,
        loginWith: {
          oauth: {
            domain: config.cognitoDomain,
            scopes: ['openid', 'email', 'profile'],
            // Must be registered on the app client in AuthStack, or Cognito rejects the redirect.
            redirectSignIn: [`${origin}/login`],
            redirectSignOut: [origin],
            responseType: 'code',
          },
        },
      },
    },
  });
}
